const colors = {
  // White
  w01: '#ffffff',

  // Greys
  g01: '#f5f5f5',
  g02: '#e0e0e0',
  g03: '#bcbcbc',
  g04: '#727272',
  g05: '#444444',

  // Blue
  b01: '#00acca',
  b02: '#0097b1',
  b03: '#00acca0d',
  d03: '#0f3d4a',
  d04: '#00272d',

  // Red
  r01: '#aa2314',
  r02: '#89130a',
  r03: '#f7eae8',

  // Green
  gr01: '#75b200',
  gr02: '#689e00',

  // Orange
  o01: '#eb9d06',

  // Tags
  t01: '#E49BB1',
  t02: '#B4C600',
  t03: '#106472',
  t04: '#edbf11',
  t05: '#bf1e16',
  t06: '#64afad',
  t07: '#00acca',
  t08: '#47a560',
  t09: '#9658b7',
  t10: '#ff9d00',

  // Facebook
  f01: '#325f95',
  f02: '#0f3d4a',
  f03: '#2556A1',

  // Loader
  l01: '#434343',
  l02: '#b4b5b5',
  l03: '#329bac'
};

export { colors };
